class PopupOnhash {
	constructor() {
		this._init()
	}
	_init() {
		this.els = document.querySelectorAll('[data-popup-onhash]')
		if(this.els.length == 0) {
			return
		}

		this.elBody = document.querySelector('[data-body]')

		this.els.forEach(el=> {
			el.addEventListener('click', () => this.deleteSearch('popup'))

			window.addEventListener('popstate', () => this.checkSearchFor(el))
			this.checkSearchFor(el)
		})
		document.querySelectorAll('[data-popup-onhash-action]').forEach(action => {
			const param = action.dataset.popupOnhashAction
			action.addEventListener('click', (e) => {
				e.preventDefault()
				this.setSearch('popup', param)
				return false
			})
		})
	}
	getSearch(param) {
		const params = new URLSearchParams(window.location.search)
		return params.get(param)
	}
	setSearch(param, newSearch) {
		const params = new URLSearchParams(window.location.search)
		params.set(param, newSearch)
		this.updateURL(params)
		this.dispatchEvent()
	}
	deleteSearch(param) {
		const params = new URLSearchParams(window.location.search)
		params.delete(param)
		this.updateURL(params)
		this.dispatchEvent()
	}
	updateURL(params) {
		params.sort()
		window.history.pushState({}, '', `${location.pathname}?${params}`)
	}
	dispatchEvent() {
		const popStateEvent = new PopStateEvent('popstate', { state: null })
		window.dispatchEvent(popStateEvent)
	}
	checkSearchFor(el) {
		if(this.getSearch('popup') == el.dataset.popupOnhash) {
			if(this.elBody) {
				this.elBody.style.overflow = 'hidden'
			}
			el.style.display = ''
		}
		else {
			if(this.elBody) {
				this.elBody.style.overflow = ''
			}
			el.style.display = 'none'
		}
	}
}

export default PopupOnhash